var _style, _rect, _rect2, _rect3, _polygon, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuminairewiththreeelement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "16.1px",
    height: "16.1px",
    viewBox: "0 0 16.1 16.1",
    style: {
      enableBackground: "new 0 0 16.1 16.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.1;stroke-miterlimit:10;}\n\t.st1{fill:none;}\n\t.st2{font-family:'Calibri';}\n\t.st3{font-size:5.3396px;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.1;stroke-miterlimit:10;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Luminaire with three element") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 7.7,
    className: "st0",
    width: 16,
    height: 1.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 5.1,
    className: "st0",
    width: 0.5,
    height: 6.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6,
    y: 5.1,
    className: "st0",
    width: 0.5,
    height: 6.4
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "8.6,6.3 8.9,7 7.5,10.5 7.2,9.7 "
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.4629 0 0 1 8.668 5.4095)",
    className: "st1 st2 st3"
  }, "3")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.4629 0 0 1 8.9487 6.0478)",
    className: "st4 st2 st3"
  }, "3")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuminairewiththreeelement);
export default __webpack_public_path__ + "static/media/Luminairewiththreeelement.12229c167a8f21cdfd713576d3b963be.svg";
export { ForwardRef as ReactComponent };